export const CREATE_MERCHANT = 'CREATE_MERCHANT';
export const FETCH_MERCHANTS = 'FETCH_MERCHANTS';
export const FETCH_MERCHANT = 'FETCH_MERCHANT';
export const UPDATE_MERCHANT = 'UPDATE_MERCHANT';
export const DELETE_MERCHANT = 'DELETE_MERCHANT';

export const CREATE_MERCHANT_LOCATION = 'CREATE_MERCHANT_LOCATION';
export const FETCH_MERCHANT_LOCATIONS = 'FETCH_MERCHANT_LOCATIONS';
export const FETCH_MERCHANT_LOCATION = 'FETCH_MERCHANT_LOCATION';
export const UPDATE_MERCHANT_LOCATION = 'UPDATE_MERCHANT_LOCATION';
export const DELETE_MERCHANT_LOCATION = 'DELETE_MERCHANT_LOCATION';

export const CREATE_TERMINAL = 'CREATE_TERMINAL';
export const FETCH_TERMINALS = 'FETCH_TERMINALS';
export const FETCH_TERMINAL = 'FETCH_TERMINAL';
export const UPDATE_TERMINAL = 'UPDATE_TERMINAL';
export const DELETE_TERMINAL = 'DELETE_TERMINAL';
